'use client';

import { c } from 'ui-components';
import { Skeleton } from './Skeleton';

type HorizontalFiltersSkeletonProps = {
  className?: string;
};

export const HorizontalFiltersSkeleton = ({
  className,
}: HorizontalFiltersSkeletonProps) => {
  return (
    <div className={c('flex animate-pulse items-end gap-3', className)}>
      <div className="flex gap-2">
        <Skeleton className="h-10 w-24 rounded-lg" />
        <Skeleton className="h-10 w-20 rounded-lg" />
        <Skeleton className="h-10 w-28 rounded-lg" />
      </div>
      <div className="flex-1" />
      <div>
        <Skeleton className="mb-2 h-4 w-14" />
        <Skeleton className="h-10 w-[180px] rounded-lg" />
      </div>
    </div>
  );
};
